export enum DoughnutWarningPluginId {
  SmoothTransitionBetweenSegments = 'smoothTransitionBetweenSegments',
  Background = 'background'
}
